import { Flex, Icon, Box, Button } from '@chakra-ui/react';
import { decode } from 'js-base64';
import { useMemo, useCallback } from 'react';
import { CalendarClose } from '@kula-ai/icons-core';
import { NotificationCard } from '../../components/Card';
import { NotificationTime } from '../../components/Time';
import { KText } from '@/ui-library/components';

const ReconnectCalendarContent = ({
  notification = {},
  onClose = () => {},
}) => {
  const { custom_attributes } = notification;

  const { url } = useMemo(() => {
    try {
      if (!custom_attributes) return {};
      return JSON.parse(decode(custom_attributes));
    } catch (err) {
      console.error('Error decoding reconnect calendar notification', err);
      return {};
    }
  }, [custom_attributes]);

  const handleReauthenticate = useCallback(() => {
    if (url) {
      window.open(url, '_self');
      onClose();
    }
  }, [url, onClose]);

  return (
    <Flex alignItems="start" gap="14px">
      <Box px="12px" pt="8px" pb="10px" borderRadius="8px" bg="pastel-1-light">
        <Icon as={CalendarClose} color="error-200" w="16px" h="16px" />
      </Box>
      <Flex flexDir="column" gap="8px" alignSelf="start" flex="1">
        <KText>
          Your calendar integration has expired. Reauthenticate to share
          accurate availability for interviews.
        </KText>
        <NotificationTime notification={notification} />
        <Button
          variant="primary"
          size="sm"
          w="fit-content"
          onClick={handleReauthenticate}
          data-test-id="reauthenticate-calendar-button"
        >
          Reauthenticate
        </Button>
      </Flex>
    </Flex>
  );
};

export const ReconnectCalendarNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <ReconnectCalendarContent notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
